/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {withI18N} from "../../hoc/withI18N";
import {FlexRow} from "../../atoms/layout/FlexRow";
import Block from "../../atoms/layout/Block";
import {CONTEXTS, ProductColumn} from "../../molecules/products/ProductColumn";
import ValueColumn from "../../molecules/products/ValueColumn";
import {RowCell} from "../../atoms/layout/RowCell";
import {QuantityInput} from "../../atoms/forms/QuantityInput";
import {FormatProductPackaging} from "../../atoms/helper/FormatProductPackaging";
import {useIsMobile} from "../../hoc/hooks";

const size = { sm: 3, xxs: 6, xs: 6 };
const altSize = { sm: 3, xxs: 4, xs: 4 };

function RelatedProductRow({product, translate, quantity, updateQuantity, modal = false, addEvent, position}) {

    const isMobile = useIsMobile("1000px");

    return <Block className={"row p-flex p-flex-wrap"} style={FlexRow.styles.center}>
        <Block className={"p-flex col-xs-12 col-sm-5"}>
            <Block className={`${modal && !isMobile ? '' : 'row'} p-flex p-flex-justify`}>
                <ProductColumn product={product} context={CONTEXTS.RELATED_PRODUCTS} addEvent={addEvent} position={position}/>
            </Block>
        </Block>
        <Block className={"row p-flex p-flex-wrap p-flex-justify-content-end col-xs-12 col-sm-7 p-margin-none p-padding-none"}>
            <ValueColumn label={translate('Package')} sizes={updateQuantity ? size : altSize} isLast
                         value={<FormatProductPackaging sku={product}/>}/>
            <ValueColumn label={translate('Unit price')} sizes={updateQuantity ? size : altSize}
                         value={!product.isFreeGood ? product.unitPrice : translate('Free')}
                         altValue={!product.isFreeGood ? product.promotionUnitPrice : null} isLast/>
            { updateQuantity ? <RowCell className={"col-sm-6 is-last p-align-self-center-sm"}>
                <QuantityInput min={0} updateValue={updateQuantity} value={quantity} />
            </RowCell> : <ValueColumn sizes={altSize} label={translate("Amount")} value={"" + quantity} isLast/> }
            <ValueColumn className={"hide-mobile"}></ValueColumn>
        </Block>
    </Block>;

}

export default withI18N(RelatedProductRow);
